import React, { createContext, useCallback, useState } from 'react'
import ChartContainer from './ChartContainer'
//@ts-ignore
export const Context = createContext()
export default function KlineChartParent(props: any) {
  const [container, setContainer] = useState(false)
  const handleRef = useCallback(ref => setContainer(ref), [])
  return <div ref={handleRef}>{container && <ChartContainer {...props} container={container} />}</div>
}
